import axios from 'axios';
import store from '../../../../store/index';
const productRequest = axios.create({
  baseURL: `${process.env.VUE_APP_API_PATH}${process.env.VUE_APP_API_UUID}/ec/product`,
});

productRequest.interceptors.request.use(
  confing => {
    // startLoading();
    store.commit('SET_LOADING', true);
    return confing;
  },
  error => {
    store.commit('SET_LOADING', false);
    return Promise.reject(error);
  },
);

//響應攔截
productRequest.interceptors.response.use(
  response => {
    // endLoading();
    store.commit('SET_LOADING', false);
    return response;
  },
  error => {
    store.commit('SET_LOADING', false);
    return Promise.reject(error);
  },
);

export default productRequest;
